export default "__VITE_ASSET__CFGYxHUh__"